import 'phoenix_html'
import {initElm} from './elm'
import FastClick from 'fastclick'
import Fingerprint2 from './fingerprint2.min'
import {initFilters} from './filters'

if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function () {
    SoPost.FastClick.attach(document.body)

    const elmDiv = document.getElementById('elm-main')
    const elmFlags = document.getElementById('gbc-flags')

    if (elmDiv) {
      // Clear any fragment from the URL (#) to ensure the user goes to the first page on load
      if (window.history && window.history.pushState) {
        history.pushState('', document.title, window.location.pathname)
      } else {
        window.location.hash = ''
      }

      if (elmFlags) {
        SoPost.initElm(elmDiv, JSON.parse(elmFlags.value))
      } else {
        console.log(SoPost)
        console.log(SoPost.Filters)
        SoPost.initFilters(elmDiv)
      }
    }
  }, false)
}

export { initElm, FastClick, Fingerprint2, initFilters }

//Raven.config('https://af47742f713648238c7ba1808da354a9@sentry.io/168653').install()



// WEBPACK FOOTER //
// ./js/app.js